import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import { withRouter } from 'react-router';

import BookPageHeader from 'rebook/apps/books/components/BookPageHeader';
import * as BookDetailActions from 'rebook/apps/books/actions/BookDetailActions';
import * as PlayerActions from 'rebook/apps/base/actions/PlayerActions';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import BooksetsCarousel from 'rebook/apps/base/components/BooksetsCarousel';


import BookDetailReviewList from './BookDetailReviewList';
import BookDetailAuthorBookList from './BookDetailAuthorBookList';
import BookDetailSeriesList from './BookDetailSeriesList';
import BookDetailAnnotation from './BookDetailAnnotation';
import BookDetailFact from './BookDetailFact';
import BookDetailCitationList from './BookDetailCitationList';
import BookDetailUserBookshelves from './BookDetailUserBookshelves';
import SimilarBookList from './SimilarBookList';

import styles from './style.scss';


class BookDetailView extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { match, location } = this.props;
    // componentDidMount is never called server side
    this.props.BookDetailActions.fetchInitialData(match, location);
  }

  componentWillUnmount() {
    this.props.BookDetailActions.resetData();
  }

  static fetchInitialDataForServer(match, store) {
    return store.dispatch(BookDetailActions.fetchInitialData(match));
  }

  componentWillReceiveProps({ match, location }) {
    // refetch book data for the component on url or user update
    const currentBookSlug = this.props.match.params.bookSlug;
    const newBookSlug = match.params.bookSlug;
    if (newBookSlug && newBookSlug !== currentBookSlug) {
      this.props.BookDetailActions.resetData();
      this.props.BookDetailActions.fetchInitialData(match, location);
    }
  }

  componentDidUpdate(prevProps) {
    const { book } = this.props.bookDetail;
    if (prevProps.user !== this.props.user) {
      this.props.BookDetailActions.fetchDetail(this.props.match);
      this.props.BookDetailActions.fetchBookUserBookshelf(book);
    }
  }

  showPlayer() {
    const { player, bookDetail } = this.props;
    const { book } = bookDetail;

    if (player.bookId !== book.id) {
      this.props.PlayerActions.setBookData(book);
    }
    this.props.PlayerActions.showPlayer();
  }

  render() {
    const { user, bookDetail, route } = this.props;
    const {
      book, authorBooks, seriesList, reviews, citations, userBooksets,
      editorBooksets, userBookshelfList, similarBooks, connectedBook,
      authorAudioBooks,
    } = bookDetail;

    const isAudioBook = get(book, 'type', 'text') === 'audio';
    const isForRent = get(route, 'path', '').indexOf('/r/') !== -1;

    return (
      <div className={isAudioBook ? 'isAudioBook' : 'isTextBook'}>
        <div className={styles.breadcrumbs}>
          <BreadCrumbs links={[
            { text: 'Библиотека', url: '/catalog/' },
            { text: get(book, 'main_author.cover_name', ''), url: get(book, 'main_author.absolute_url', '') },
            {
              text: `${isAudioBook ? 'Аудиокнига ' : ''}«${get(book, 'name', '')}»`,
              url: get(book, 'absolute_url', ''),
            },
          ]} />
        </div>

        <BookPageHeader
          isForRent={isForRent}
          book={book}
          connectedBook={connectedBook}
          bookDetail={bookDetail}
          showPlayer={this.showPlayer.bind(this)} />

        <div className="themeWhite">
          {book && (
            <div className={styles.bookPageContent}>
              <BookDetailAnnotation book={book} user={user} />
            </div>
          )}
        </div>
        <div className="backgroundContainer themeGrey">
          <div className={styles.bookPageContent}>
            {user && book && userBookshelfList && userBookshelfList.length > 0 && (
              <BookDetailUserBookshelves
                bookshelves={userBookshelfList}
                userId={user.id} />
            )}
            {book && seriesList && (
              <BookDetailSeriesList book={book} seriesList={seriesList} />
            )}
            {book && reviews && (
              <BookDetailReviewList reviews={reviews} book={book} />
            )}
            {book && citations && (
              <BookDetailCitationList citations={citations} book={book} />
            )}
            {book && book.interesting_facts && (
              <BookDetailFact book={book} facts={book.interesting_facts} />
            )}
            {book && authorBooks && (
              <BookDetailAuthorBookList book={book} authorBooks={authorBooks} authorAudioBooks={authorAudioBooks} />
            )}
            {book && get(editorBooksets, 'objects.length', 0) > 0 && (
              <BooksetsCarousel
                title={isAudioBook ? 'Подборки с этой аудиокнигой' : 'Подборки с этой книгой'}
                booksets={editorBooksets.objects} />
            )}
            {book && get(userBooksets, 'objects.length', 0) > 0 && (
              <BooksetsCarousel
                title={isAudioBook ? 'Полки других слушателей' : 'Полки других читателей'}
                booksets={userBooksets.objects} />
            )}
            {book && similarBooks && (
              <SimilarBookList book={book} bookList={similarBooks} isAudioBook={isAudioBook} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

BookDetailView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      bookSlug: PropTypes.string.isRequired,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    bookDetail: state.bookDetail,
    user: state.user,
    player: state.player,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    BookDetailActions: bindActionCreators(BookDetailActions, dispatch),
    PlayerActions: bindActionCreators(PlayerActions, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BookDetailView));
